import { cn } from '@latitude/token-utils';

import {
  SkeletonCardListItem,
  type SkeletonCardListItemProps,
} from './SkeletonCardListItem';

export type SkeletonCardListItemListProps = Omit<
  SkeletonCardListItemProps,
  'data-testid'
> & {
  /** Number of skeleton rows to display (default: 3) */
  count?: number;
};

export const SkeletonCardListItemList = ({
  count = 3,
  className,
  ...itemProps
}: SkeletonCardListItemListProps) => (
  <div
    className={cn('flex flex-col gap-4', className)}
    data-testid="skeleton-card-list-item-list"
  >
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonCardListItem
        // oxlint-disable-next-line react/no-array-index-key -- static placeholders, no identity to key on
        key={`skeleton-card-list-item-${index}`}
        {...itemProps}
      />
    ))}
  </div>
);
